import {createContext} from "react";
import {IConsultaiApiContext} from "./interfaces/IConsultaiApiContext";


const ConsultaiApiContext = createContext<IConsultaiApiContext|undefined>(undefined);
export default ConsultaiApiContext;

